export function menu() {
  const main = document.getElementById('main');
  const topMenu = document.getElementById('top-header');
  const topMenuHeight = topMenu.offsetHeight;
  main.style.marginTop = topMenuHeight + 'px';
  const sections = document.querySelectorAll(".section[id]");
  const firstAnchor = document.querySelector(".nav-primary .nav-item a[href*='home']");
  const firstAnchorVertical = document.querySelector(".nav-secondary .nav-item a[href*='home']");
  
  if(firstAnchor) {
    firstAnchor.classList.add('active');
  }
  if(firstAnchorVertical) {
    firstAnchorVertical.classList.add('active');
  }
  document.addEventListener('scroll', function () {
    navHighlighter('.nav-primary',firstAnchor);
    navHighlighter('.nav-secondary',firstAnchorVertical);
  });

  function navHighlighter(nav,anchor) {
    // Get current scroll position
    let scrollY = window.pageYOffset;

    // Now we loop through sections to get height, top and ID values for each
    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - topMenuHeight;
      let sectionId = current.getAttribute("id");
      
      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        let el = document.querySelector(nav + " .nav-item a[href*=" + sectionId + "]");
        if (el) {
          el.classList.add("active");
        }
      } else {
        let el = document.querySelector(nav + " .nav-item a[href*=" + sectionId + "]");
        if (el) {
          el.classList.remove("active");
        } 
      }
      if (scrollY > 10) {
        topMenu.classList.add('sticky');
      } else {
        topMenu.classList.remove('sticky');
        anchor.classList.add('active');
      }
    });
  }

}
